import { useMemo } from 'react';
import { PrinterProfile } from '@oolio-group/domain';
import { useSession } from './useSession';

/** Resolves a printer profile's notifier display style (full content vs summary) from
 * session, shared by DocketOtherItemsLabel and ViewAllCoursesLabel so the profile-shape
 * lookup and its fallback can't diverge between the two drawer entry points. */
export function useNotifierDisplayStyle(printerProfileId?: string) {
  const { session } = useSession();

  const assignedProfiles = useMemo(
    () =>
      session?.kitchenDisplay?.printerProfiles?.map((x: PrinterProfile) => ({
        id: x.id,
        displayStyle: x.notifiers?.displayStyle,
      })) || [],
    [session?.kitchenDisplay?.printerProfiles],
  );

  return useMemo(
    () => assignedProfiles.find(p => p.id === printerProfileId)?.displayStyle,
    [assignedProfiles, printerProfileId],
  );
}
